<div mat-dialog-content>
    <div class="docLoadM-container-button">
        <button mat-icon-button (click)="close()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <p class="title">Grupos</p>
    <div class="docLoadM-container-button">
        <div class="docLoadM-group">
            <input type="text" class="forms-control" placeholder="" (keyup)="filter($event)">
            <mat-icon class="blue-color">search</mat-icon>
        </div>
    </div>

    <table class="docLoadM-table" mat-table [dataSource]="dataSource" #table>
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>Id</th>
            <td mat-cell *matCellDef="let item">{{item.id}}</td>
        </ng-container>

        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Grupo</th>
            <td mat-cell *matCellDef="let item">{{item.description}}</td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Asignar</th>
            <td mat-cell *matCellDef="let item">
                <div class="docLoadM-container-checkbox" matRipple [matRippleCentered]="true" [matRippleRadius]="40">
                    <div class="docLoadM-checkbox">
                        <input [id]="item.id" type="checkbox" [checked]="item.active"
                            (click)="checked($event.srcElement,item.id)">
                        <label class="docLoadM-label" [for]="item.id">
                            <mat-icon>done</mat-icon>
                        </label>
                    </div>
                </div>
            </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    </table>
</div>